import dayjs, { type Dayjs } from "dayjs";
import { outputTypeEnum } from "kubb";
import { useState } from "react";
import { FeatureAnnouncementBanner } from "../../../components/Banner";
import { PageHeadingBlock } from "../../../components/Theme/heading";
import { useCreateReportExecution } from "../../../hooks/createEntity";
import { useRequiredSelectedCompany } from "../../../reducers/company";
import ReportExecutionCreator from "../executions/ReportExecutionCreator";
import ReportExecutionList from "../executions/ReportExecutionList";

function TimeSeriesDataExportPage() {
  const company = useRequiredSelectedCompany();
  const create = useCreateReportExecution(company.company_id);
  const [lastChange, setLastChange] = useState<Dayjs>();

  const handleCreate: typeof create.update = async (...args) => {
    const result = await create.update(...args);
    setLastChange(dayjs());
    return result;
  };

  return (
    <>
      <PageHeadingBlock>Export Aggregated Data</PageHeadingBlock>
      <FeatureAnnouncementBanner
        featureId="2026-01-15-export-units"
        message="We've updated this feature to support units - it's been one of our most frequently requested features. By default we now will export energy in kWh and not Wh as before. You can switch back to Wh using the dropdown if you need it."
        margin={2}
      />
      <ReportExecutionCreator
        company={company}
        create={handleCreate}
        outputTypeFilter={[
          outputTypeEnum.AGGREGATED_DATA,
          outputTypeEnum.ALL_DATA,
        ]}
      />
      <PageHeadingBlock>Previous Executions</PageHeadingBlock>

      <ReportExecutionList
        company_id={company.company_id}
        params={{
          format: [outputTypeEnum.AGGREGATED_DATA, outputTypeEnum.ALL_DATA],
        }}
        cursor={{ max_items: 15 }}
        lastChange={lastChange}
      />
    </>
  );
}

export default TimeSeriesDataExportPage;
